import client from "../client";

export interface TopupVemlentineBetResponse {
  AmountA: number;
  AmountB: number;
  IsCredit: boolean;
}

export default function API(): Promise<TopupVemlentineBetResponse> {
  return client
    .post(`/gameinhouse/venlentine/bet`)
    .then((response) => response.data);
}
